module.exports = {
	"locale_native_name": "English",
	"_internal": {
		"currency_symbol": "$"
	},
	"format": {
		"time": {
			"datetime": "DD/MM/YYYY HH:mm",
			"date": "DD/MM/YYYY",
			"time": "HH:mm"
		},
		"datepicker": "dd/MM/yyyy",
		"number": {
			"number": "0,0",
			"decimal": "0,0.00",
			"currency": "$0,0[.]00"
		},
		"age": {
			"min": "{{ age }}",
			"max": "{{ age }}+"
		}
	},
	"fn": {
		"datetime": "{{ timestamp, datetime }}",
		"time": "{{ timestamp, time }}",
		"date": "{{ timestamp, date }}",
		"number": "{{ value, number }}",
		"decimals": "{{ value, decimals }}",
		"currency": "{{ value, currency }}",
		"age": "{{ age, age }}",
		"gender": "{{ genders, gender }}",
		"complex": {
			"location_type": "$t(terms.location.type.{{ location_type }})",
			"location_type_targeting": "$t(terms.location.type.targeting.{{ targeting_type }})",
			"location_placeholder": "$t(terms.location.placeholder.{{ location_type }})",
			"campaign_step": "$t(terms.campaign_step.{{ campaign_step }})",
			"example_title": "$t(terms.example_title.{{ example_slug }})",
			"advantage_title": "$t(terms.advantages.{{ advantage_slug }}.title)",
			"advantage_description": "$t(terms.advantages.{{ advantage_slug }}.description, { 'distanceUnit': \"{{ distanceUnit }}\" })",
			"faq_title": "$t(terms.faq.{{ faq_slug }}.title)",
			"faq_description": "$t(terms.faq.{{ faq_slug }}.description)",
			"distance_unit": "$t(terms.distance_unit.{{ distance_unit }})",
			"mode": "$t(terms.mode.{{ mode }}, { 'duration': \"{{ duration }}\" })",
			"format": "$t(terms.format.name.{{ format }})",
			"format_description_short": "$t(terms.format.description.{{ format }}.short, { 'extraCost': \"{{ extraCost }}\" })",
			"format_description_full": "$t(terms.format.description.{{ format }}.full, { 'extraCost': \"{{ extraCost }}\" })",
			"landing_page_type": "$t(terms.landing_page_type.{{ landing_page_type }})",
			"facebook_page_mode_name": "$t(terms.facebook_page_mode.name.{{ facebook_page_mode }})",
			"facebook_page_mode_description": "$t(terms.facebook_page_mode.description.{{ facebook_page_mode }}, { 'price': \"{{ price }}\" })",
			"reach-warning": "$t(terms.reach-warning.{{ mode }})",
			"error": "$t(error.{{ error_group }}.{{ error_name }})",
			"optimize-towards": "{{ users, number }} $t(terms.format.mode.{{ mode }}) $t(terms.format.optimize-for.{{ goal }})",
			"brief-placeholder": "$t(terms.brief-description.{{ type }})",
			"marketing_goal_name": "$t(terms.marketing_goals.{{ slug }}.name)",
			"marketing_goal_description": "$t(terms.marketing_goals.{{ slug }}.description)",
			"campaign_goal_ideal_for": "$t(terms.campaign-goal_ideal-for.{{goal_type}})"
		}
	},
	"terms": {
		"language": {
			"name": {
				"en": "English",
				"en_IE": "English",
				"en_UK": "English",
				"en_GB": "English",
				"en_US": "English",
				"us": "English",
				"es": "Spanish",
				"es_ES": "Spanish",
				"de": "German",
				"de_DE": "German",
				"ru": "Russian",
				"ru_RU": "Russian",
				"it": "Italian",
				"it_IT": "Italian",
				"fr": "French",
				"fr_FR": "French",
				"el": "Greek",
				"el_GR": "Greek",
				"et": "Estonian",
				"et_EE": "Estonian",
				"nl": "Dutch",
				"nl_BE": "Dutch",
				"ph": "English",
				"ph_EN": "English",
				"ml": "English",
				"en_ML": "English",
				"en_SG": "English",
				"en_MY": "English"
			}
		},
		"cta": {
			"APPLY_NOW": "Apply Now",
			"BOOK_TRAVEL": "Book Now",
			"CONTACT_US": "Contact Us",
			"LEARN_MORE": "Learn More",
			"NO_BUTTON": "Empty cta",
			"SHOP_NOW": "Shop Now",
			"SIGN_UP": "Sign Up",
			"WATCH_MORE": "Watch More",
			"DOWNLOAD": "Download",
			"MESSAGE_PAGE": "Send Message",
			"GET_SHOWTIMES": "Get showtimes",
			"LISTEN_NOW": "Listen Now",
			"SEE_MENU": "See Menu",
			"REQUEST_TIME": "Request Time",
			"GET_QUOTE": "Get Quote",
			"SUBSCRIBE": "Subscribe",
			"DEFAULT": "CALL TO"
		},
		"campaign_step": {
			"campaign-setup": "Setup",
			"campaign-target": "Target",
			"campaign-offer": "Offer",
			"campaign-format": "Format",
			"campaign-settings": "Settings",
			"campaign-checkout": "Checkout"
		},
		"campaign_status": {
			"INI": "Created",
			"WRK": "Posts Creation Started",
			"CAP": "Posts Approved",
			"ONL": "Campaign Online",
			"FIN": "Campaign Finished",
			"CAN": "Campaign Deleted"
		},
		"example_title": {
			"restaurant": "Restaurant",
			"wellness": "Wellness",
			"hairdresser": "Hairdresser",
			"hotel": "Hotel",
			"shopping": "Shopping",
			"dentist": "Dentist",
			"auto": "Auto",
			"hotels": "Hotels",
			"beauty-center": "Beauty Center",
			"car-dealership": "Car dealership",
			"electrician": "Electrician",
			"restaurants": "Restaurants",
			"jewelry": "Jewelry",
			"plumbers": "Plumbers",
			"clothing": "Clothing",
			"festivity": "Festivity",
			"decoration-services": "Decoration Services",
			"events": "Events",
			"health": "Health",
			"hobbies": "Hobbies",
			"finance": "Finance",
			"renovations": "Renovations",
			"feeding": "Feeding",
			"multiservices": "Multiservices",
			"veterinary": "Veterinary",
			"furniture": "Furniture",
			"real-estate": "Real Estate",
			"roofing": "Roofing",
			"driving": "Driving",
			"flowers": "Flowers",
			"gastronomy": "Gastronomy",
			"traveling": "Traveling",
			"bar": "Bar",
			"bakeries": "Bakeries",
			"private-schools": "Private Schools",
			"law": "Law",
			"funeral-honours": "Funeral Honours"
		},
		"advantages": {
			"local-advertising": {
				"title": "Local advertising",
				"description": "Communicate with the people that are close to your business by selecting the city and a radius in $t(fn.complex.distance_unit, {'distance_unit': \"{{ distanceUnit }}\" }), or selecting multiple cities, with no limits."
			},
			"guaranteed-reach": {
				"title": "Guaranteed reach and targeted communication",
				"description": "With Facebook Planner you are sure to reach a number of people where it matters to you. Your message will be seen more times by the users to ensure that your campaign has the greatest impact.\n"
			},
			"more-relevance": {
				"title": "More relevance for your campaigns",
				"description": "Increase the relevance of your advertising by defining gender and age of the users you want to reach. Only the users with the profile you selected will see your message.\n"
			},
			"mobile-campaigns": {
				"title": "Mobile campaigns",
				"description": "The campaigns created with Facebook Planner will be shown also on smartphones, to reach users on the go and when they are close to your business.\n"
			}
		},
		"placement": {
			"facebook": "Facebook",
			"facebook-instagram": "Facebook & Instagram"
		},
		"misc": {
			"no-records": "There are no records to show",
			"search": "Search",
			"show-more": "Show more",
			"show-less": "Show less",
			"users": "Users",
			"yes": "Yes",
			"no": "No",
			"proceed": "Proceed",
			"cancel": "Cancel",
			"confirm": "Confirm",
			"remove": "Remove",
			"loading": "Loading..",
			"close": "Close",
			"download": "Download",
			"back-to-campaign": "Back to campaign"
		},
		"location": {
			"type": {
				"address": "Address",
				"city": "City",
				"zip": "Zip",
				"region": "Region",
				"country": "Country",
				"targeting": {
					"home": "home",
					"travel_in": "tourists"
				}
			},
			"placeholder": {
				"address": "Search addresses..",
				"city": "Search cities..",
				"zip": "Search zips..",
				"region": "Search regions..",
				"country": "Search countries.."
			}
		},
		"distance_unit": {
			"km": "km",
			"mi": "mi"
		},
		"gender": {
			"all": "All",
			"male": "Male",
			"female": "Female"
		},
		"mode": {
			"oneoff": "One-off",
			"subscription": "Subscription",
			"multi_month": "{{ duration }} Months"
		},
		"format": {
			"name": {
				"image": "Link",
				"slideshow": "Slideshow",
				"carousel": "Carousel",
				"video": "Video"
			},
			"description": {
				"image": {
					"full": "__Most suitable for:__\n- Broad business messaging\n- Focus on one specific product or service\n- Single image\n- Single landing page\n",
					"short": "Suitable for focusing on one specific product or service"
				},
				"carousel": {
					"full": "__Most suitable for:__\n- Multiservice or multiproduct messaging\n- Max 5 images\n- Max 5 landing pages\n",
					"short": "Suitable for multiservice or multiproduct messaging"
				},
				"slideshow": {
					"full": "__Most suitable for:__\n- Multiservice or multiproduct awareness\n- Min 3, max 10 images\n- Engaging users with a looping video\n",
					"short": "Suitable for multiservice or multiproduct awareness with a looping video"
				},
				"video": {
					"full": "__Suitable for:__\n- Be at the centre of daily discovery\n- Reach people across devices\n- Format: .MOV, .MP4, .AVI or .GIF files\n",
					"short": "Suitable for multiservice or multiproduct messaging"
				}
			},
			"mode": {
				"oneoff": "Users,",
				"subscription": "Users every month,"
			},
			"optimize-for": {
				"local_offers": "optimized towards saved offers",
				"lead_generation": "optimized towards leads generated"
			}
		},
		"reset": {
			"format": "Campaign format not found, resetting to default value"
		},
		"landing_page_type": {
			"webpage": "Web page",
			"facebookpage": "FB Page"
		},
		"facebook_page_mode": {
			"name": {
				"basic": "Basic (free)",
				"optimized": "Optimized page",
				"no-page": "$t(terms.misc.no)"
			},
			"description": {
				"basic": "Basic: a FB page will be created with basic information such as client name and address",
				"optimized": "Optimized $t(fn.currency, {'value': \"{{ price }}\" })"
			}
		},
		"interest": {
			"anything": "Anything"
		},
		"reach-warning": {
			"oneoff": "Not enough reach for oneoff campaign",
			"subscription": "Not enough reach for subscription campaign",
			"multi_month": "Not enough reach for multi-month campaign"
		},
		"campaign-goal": {
			"impressions": "Impressions",
			"clicks": "Clicks",
			"lead_generation": "Lead generation",
			"traffic": "Traffic",
			"local_offers": "$t(pos.setup.optimize-for.local_offers)",
			"reach_and_click": "$t(pos.setup.optimize-for.reach_and_click)",
			"reach_frequency": "$t(pos.setup.optimize-for.reach_frequency)",
			"post_engagement": "$t(pos.setup.optimize-for.post_engagement)"
		},
		"brief-description": {
			"reach_and_click": "Describe the unique selling points or characteristics the merchant has to offer",
			"reach_frequency": "Describe the products, services or characteristics to underline",
			"post_engagement": "Describe the products, services or characteristics to underline",
			"lead_generation": "Describe the discount, savings or offers(s) to promote",
			"local_offers": "Describe the discount, savings or offers(s) to promote"
		},
		"datetime": {
			"months_short": {
				"1": "Jan",
				"2": "Feb",
				"3": "Mar",
				"4": "Apr",
				"5": "May",
				"6": "Jun",
				"7": "Jul",
				"8": "Aug",
				"9": "Sep",
				"10": "Oct",
				"11": "Nov",
				"12": "Dec"
			},
			"months_long": {
				"1": "January",
				"2": "February",
				"3": "March",
				"4": "April",
				"5": "May",
				"6": "June",
				"7": "July",
				"8": "August",
				"9": "September",
				"10": "October",
				"11": "November",
				"12": "December"
			}
		},
		"datepicker": {
			"hour-tip": "Select Hour,",
			"minute-tip": "Select Minute,",
			"second-tip": "Select Second,",
			"year-suffix": "",
			"days_short": {
				"su": "Su",
				"mo": "Mo",
				"tu": "Tu",
				"we": "We",
				"th": "Th",
				"fr": "Fr",
				"sa": "Sa"
			}
		},
		"objective-texts": {
			"format": "$t(terms.objective-texts.{{ slug }}.name)",
			"Promote business": {
				"name": "Promote business"
			},
			"Promote specific product/service": {
				"name": "Promote specific product/service"
			},
			"Communicate a regular/seasonal promotion (not one-off, eg. 50% of every Sunday)": {
				"name": "Communicate a regular/seasonal promotion (not one-off, eg. 50% of every Sunday)"
			},
			"Make location/phone number more visible": {
				"name": "Make location/phone number more visible"
			},
			"Promote the possibility to get in touch for a booking or in appointment": {
				"name": "Promote the possibility to get in touch for a booking or in appointment"
			},
			"promote-business": {
				"name": "Promote business"
			},
			"promote-specific-productservice": {
				"name": "Promote specific product/service"
			},
			"communicate-a-regularseasonal-promotion-not-one-off-eg-50-of-every-sunday": {
				"name": "Communicate a regular/seasonal promotion (not one-off, eg. 50% of every Sunday)"
			},
			"make-locationphone-number-more-visible": {
				"name": "Make location/phone number more visible"
			},
			"promote-the-possibility-to-get-in-touch-for-a-booking-or-in-appointment": {
				"name": "Promote the possibility to get in touch for a booking or in appointment"
			}
		},
		"target_change_status": {
			"pending": "Pending",
			"applied": "Applied"
		}
	},
	"draft_field": {
		"title": {
			"created": "Created",
			"locations": "Locations",
			"step": "Step",
			"target": "Target",
			"name": "Campaign name",
			"company": "Company",
			"status": "Status",
			"code": "Code",
			"cloneOf": "Clone Of",
			"cloneFor": "Clone By",
			"radius": "Radius",
			"age": "Age",
			"gender": "Gender",
			"interest": "Interest",
			"budget": "Budget",
			"potential-reach": "Potential reach",
			"guaranteed-reach": "Guaranteed reach",
			"format": "Format",
			"customer-remote-id": "Customer ID",
			"customer-email": "Customer email",
			"customer-language": "Customer language",
			"phone": "Phone number",
			"salesrep_phone": "Sales representative phone number",
			"facebook-email": "Facebook email",
			"facebook-page": "Facebook page",
			"objective": "Objective",
			"brief": "Brief",
			"images": "Images",
			"start-date": "Start date",
			"mode": "Mode",
			"landing-page": "Landing page",
			"creator": "Creator",
			"language": "Language",
			"coupon-code": "Coupon code",
			"form-question": "Form question",
			"campaign-goal": "Campaign goal",
			"estimated-leads": "Estimated leads",
			"estimated-clicks": "Estimated clicks",
			"offer-settings": "Offer Settings",
			"number-of-refresh": "Numer of refresh",
			"lead-email": "Lead delivery email",
			"lead-phone": "Lead delivery phone number",
			"target_change_status": "Change of target",
			"privacy-policy-link": "Lead form privacy policy",
			"duration": "Duration",
			"placement": "Placement"
		},
		"tooltip": {
			"lead-email": "Contact email of the person who is going to receive leads",
			"lead-phone": "Phone number of the person who is going to receive leads",
			"facebook-email": "Email used to log on Facebook in order to receive notifications",
			"privacy-policy-link": "A privacy policy is required when collecting personal information through Facebook Lead Ads"
		},
		"format": {
			"language": "$t(terms.language.name.{{ type }})",
			"created": "$t(fn.date, { 'timestamp': \"{{ created }}\" })",
			"target": "$t(fn.number, { 'value': \"{{ users }}\" }) $t(terms.misc.users)",
			"location": "$t(fn.complex.location_type, { 'location_type': \"{{ type }}\" }): {{ name }}",
			"location_with_radius": "$t(fn.complex.location_type, { 'location_type': \"{{ type }}\" }): {{ name }} (+{{ radius }} $t(fn.complex.distance_unit, { 'distance_unit': \"{{ unit }}\" }))",
			"step": "$t(fn.complex.campaign_step, { 'campaign_step': \"{{ step }}\" })",
			"radius": "$t(fn.number, { 'value': \"{{ radius }}\" }) $t(fn.complex.distance_unit, { 'distance_unit': \"{{ unit }}\" })",
			"age": "$t(fn.age, { 'age': \"{{ from }}\" }) to $t(fn.age, { 'age': \"{{ to }}\" })",
			"gender": "$t(fn.gender, { 'genders': \"{{ genders }}\" })",
			"budget": "$t(fn.currency, { 'value': \"{{ budget }}\" })",
			"mode": "$t(fn.complex.mode, { 'mode': \"{{ mode }}\", 'duration': \"{{ duration }}\" })",
			"format": "$t(fn.complex.format, { 'format' : \"{{ format }}\" })",
			"format-extracost": "+$t(fn.currency, { 'value': \"{{ cost }}\" }) one off",
			"landing-page": "$t(fn.complex.landing_page_type, { 'landing_page_type' : \"{{ type }}\" }): {{ url }}",
			"facebook-page-mode": "$t(fn.complex.facebook_page_mode_name, { 'facebook_page_mode' : \"{{ mode }}\" })",
			"facebook-page-extracost": "+$t(fn.currency, { 'value': \"{{ cost }}\" }) one off",
			"start-date": "$t(fn.date, { 'timestamp': \"{{ date }}\" })",
			"clicks": "{{ min, number }} - {{ max, number }}"
		},
		"placeholder": {
			"company": "Your company",
			"customer-remote-id": "Customer ID",
			"customer-email": "client@company.com",
			"phone": "Phone number",
			"facebook-email": "client@company.com",
			"landing-page": "https://www.facebook.com/pagename",
			"web-page": "https://www.website.com/",
			"brief": "Describe your goal",
			"objective": "Choose an objective",
			"change": "Change",
			"images": "Drop files here or click to upload",
			"facebook-page": "Page name",
			"name": "Add name",
			"start-date": "Select Date",
			"form-question": "How to contact you?",
			"lead-email": "client@company.com",
			"lead-phone": "Phone number",
			"privacy-policy-link": "https://example.com/privacy-policy"
		},
		"offer_settings": {
			"header": "Offer details",
			"title": "Title",
			"details": "Details",
			"code_type": "Code type",
			"redeem": "Redeem",
			"t_c": "T&C",
			"offer_url": "Offer url",
			"placeholder": {
				"code": "Insert the unique code to use in the offer"
			},
			"code_type_options": {
				"empty": "Select code type",
				"none": "No code",
				"one": "One code",
				"unique": "Unique codes"
			},
			"redeem_options": {
				"empty": "Select redeem place(s)",
				"store": "In Store",
				"online": "Online",
				"both": "Both"
			},
			"same_offer": "Use the same offer after its expiration date"
		}
	},
	"error": {
		"validation": {
			"code_type": "Code type field is required",
			"redeem_options": "Reddem option field is required",
			"unique_code": "Field must contain a code",
			"email": "Field must contain valid email address",
			"required": "Field is required",
			"isEmail": "$t(error.validation.email)",
			"isUrl": "Field must contain a valid URL",
			"isFb": "Field must not contain FB page",
			"maxLength": "Max length exceeds {{length}} characters",
			"minLength": "Min length must be at least {{length}} characters",
			"isPhoneNr": "Field must contain only numbers",
			"numeric": "Field must contain only numbers",
			"validateCommaSeparatedEmails": "Field must contain one or more comma separated emails",
			"isAppstore": "App store links are not supported"
		},
		"check-all-fields": "Please check all fields marked with red color",
		"check-offer-fields": "Please check offer settings modal window",
		"upload-file": "Error during file uploading",
		"email-and-or-password-invalid": "Email and/or password are invalid",
		"maximum-interests": "You can't select more than {{ count }} interests"
	},
	"pos": {
		"header": {
			"create": "Create a Campaign",
			"saved": "Saved Proposals",
			"examples": "Examples",
			"user": "Hello, {{ name }}",
			"signout": "Sign out",
			"setup-offline-mode": "Setup offline mode",
			"go-to-fam": "Go to Fulfillment Tool"
		},
		"login": {
			"welcome": "Welcome to Facebook Ads by Yellow",
			"welcome-secondary": "With this Campaign Builder you can create proposals for your customers, access your saved campaigns and learn how your customers can benefit from advertising on Facebook\n",
			"placeholder": {
				"email": "Enter your email",
				"password": "Enter your password"
			},
			"login": "Login",
			"sso-login": "Google login",
			"forgotpassword": "Click here if you forgot your password",
			"remember-me": "Remember me",
			"empty-credentials": "Please insert valid credentials to log in the platform"
		},
		"setup": {
			"title": "Welcome to your sales tool",
			"title_leads": "Choose your perfect goal",
			"notice_leads": "You will need a privacy policy URL to save a campaign with this model",
			"notice_fb_required": "A Facebook page is required",
			"description": "Start by selecting the location of your campaign target",
			"start": "Let's start",
			"optimize-for": {
				"title": "Optimize for",
				"description": "is your goal having more views or more clicks",
				"reach_frequency": "Local visibility",
				"post_engagement": "Local visibility",
				"lead_generation": "Local leads",
				"reach_and_click": "Reach and Clicks",
				"local_offers": "Local Offers"
			}
		},
		"steps": {
			"step-name": "$t(fn.complex.campaign_step, { 'campaign_step': \"{{ step }}\" })"
		},
		"examples": {
			"tabs": {
				"advantages": "Advantages",
				"examples": "Examples",
				"faq": "FAQs"
			},
			"example": {
				"title": "$t(fn.complex.example_title, { 'example_slug': \"{{ slug }}\" })"
			},
			"advantage": {
				"title": "$t(fn.complex.advantage_title, { 'advantage_slug': \"{{ slug }}\" })",
				"description": "$t(fn.complex.advantage_description, { 'advantage_slug': \"{{ slug }}\" , 'distanceUnit': \"{{ distanceUnit }}\" })"
			},
			"faq": {
				"title": "$t(fn.complex.faq_title, { 'faq_slug': \"{{ slug }}\" })",
				"description": "$t(fn.complex.faq_description, { 'faq_slug': \"{{ slug }}\" })"
			}
		},
		"proposals": {
			"tabs": {
				"drafts": "Drafts",
				"checkout": "Check out",
				"completed": "Completed",
				"live": "Live"
			},
			"no-records": "$t(terms.misc.no-records)",
			"search": "$t(terms.misc.search)",
			"show-more": "$t(terms.misc.show-more)",
			"count": "$t(fn.number, { 'value' : \"{{ count }}\" }) $t(pos.proposals.count-end)",
			"count-end": "proposals"
		},
		"proposal": {
			"saved-campaign": "Saved campaign",
			"finalized": "Finalized",
			"email-sent": "Email sent",
			"send-email": "SEND SUMMARY VIA EMAIL",
			"duplicate": "Duplicate",
			"email-placeholder": "Email",
			"edit": "Edit",
			"change-target": "Change target",
			"upsell-price": "Change price only",
			"upsell-price-changed": "New Campaign created",
			"upsell-all": "Edit",
			"rebook-campaign": "Rebook campaign on the"
		},
		"format": {
			"proceed": "$t(terms.misc.proceed)",
			"title": "$t(fn.complex.format, { 'format' : \"{{ format }}\" })",
			"title-extracost": "(+$t(fn.currency, { 'value': \"{{ cost }}\" }) one off)",
			"reset": "$t(terms.reset.format)",
			"how-many-creative-refresh": "How many creative refresh would you like to buy?",
			"i-would-like-new-creative": "I would like a new creative",
			"modal": {
				"title": "ADV FORMAT",
				"cancel": "$t(terms.misc.cancel)",
				"confirm": "$t(terms.misc.confirm)",
				"objectives": {
					"title": "Select objective",
					"label": "Objectives"
				},
				"offers": {
					"title": "OFFER PREVIEW",
					"heading": "Offer description",
					"description": "Offers are discounts you can share with your customers on Facebook. You can create an offer ad to encourage people to shop on your website and at your physical store.\n"
				},
				"leadForm": {
					"title": "FORM PREVIEW",
					"heading": "Form description",
					"description": "The Lead Ads allows to grow inbound inquiries and capture lead information from people who have expressed intent.\nBy clicking on a lead ad, a Facebook user will see a form containing:\n\n\n- Custom question, editable in the next step;\n- pre-filled info shared on facebook by the user.\n"
				}
			},
			"description": {
				"full": "$t(fn.complex.format_description_full, { 'format': \"{{ format }}\", 'extraCost': \"{{ extraCost }}\" })",
				"short": "$t(fn.complex.format_description_short, { 'format': \"{{ format }}\", 'extraCost': \"{{ extraCost }}\" })"
			}
		},
		"offer": {
			"special_ad_category_warning": "Due to Facebook guidelines, if your campaign includes ads offering credit, employment or housing opportunities, certain targeting options might not be available and/or amended post-live.",
			"extraline-bottom": {
				"reach_and_click": "Click performance cannot be guaranteed, however this recommendation is based on our experience of managing campaigns for businesses like yours"
			},
			"context": {
				"subscription": {
					"no_frequency_reach": "every month",
					"reach": "times every month",
					"price": "per month"
				},
				"oneoff": {
					"no_frequency_reach": "times",
					"reach": "times",
					"price": null
				}
			},
			"audience-guaranteed": "Audience guaranteed",
			"campaign-budget": "Campaign Budget",
			"reach-frequency": "{{ users, number }} users reached {{ frequency, number }} $t(pos.offer.context.{{ context }}.reach)",
			"lead-generation": "Minimum {{ reach, number }} people reached $t(pos.offer.context.{{ context }}.no_frequency_reach)",
			"reach-and-click": "Minimum {{ reach, number }} people reached $t(pos.offer.context.{{ context }}.no_frequency_reach)",
			"local-offers": "Minimum {{ reach, number }} people reached $t(pos.offer.context.{{ context }}.no_frequency_reach)",
			"clicks": "feels like {{ min, number }} - {{ max, number }} clicks",
			"price": "Price {{ price, currency }} $t(pos.offer.context.{{ context }}.price)",
			"total-price": "Total price: {{ price, currency }}",
			"confirm": "$t(terms.misc.confirm)",
			"guaranteed": "Guaranteed",
			"potentital-total": "Potential (total)",
			"not-reached": "Not Reached",
			"edit-target": "Edit your target",
			"go-back": "Go back",
			"infobox-title": "Your campaign will be shown to",
			"move-to-format": "Move to format",
			"mobile-description": "Your campaign can __reach up to {{ users, number }} users__, change your reach to maximize your performance",
			"leads": "from {{ min }} up to {{ max }} estimated leads",
			"offers": "from {{ min }} up to {{ max }} estimated offers",
			"campaign-reset-mode": "Campaign mode was set to default",
			"campaign-reset-package": "Campaign package was set to default",
			"impressions": "Your campaign will bee seen {{ impressions, number }} times every month",
			"reach-total": "{{ reach, number }} people reached total",
			"extraline": ""
		},
		"target": {
			"location": {
				"add-text": "Add",
				"add": "$t(fn.complex.location_type, { 'location_type': \"{{ type }}\" })",
				"add-more": "$t(pos.target.location.add-text) $t(fn.complex.location_type, { 'location_type': \"{{ type }}\" })",
				"list-type": "$t(fn.complex.location_type, { 'location_type': \"{{ type }}\" })",
				"placeholder": "$t(fn.complex.location_placeholder, { 'location_type': \"{{ type }}\" })"
			},
			"gender": "$t(draft_field.title.gender)",
			"age": "$t(draft_field.title.age)",
			"placement": "$t(draft_field.title.placement)",
			"interest": {
				"caption": "$t(draft_field.title.interest)",
				"modal": {
					"title": "Select interest",
					"no-interest": "No interest",
					"confirm": "$t(terms.misc.confirm)"
				}
			},
			"language": "$t(draft_field.title.language)",
			"confirm": "$t(terms.misc.confirm)",
			"not-enough-button": "Not enough reach",
			"not-enough-toast": "Not enough reach. Please widen your target selection.",
			"move-to-offer": "Move to Offer",
			"potential-users": "Potential users",
			"change-setup": "Change setup",
			"facebook-unable-to-provide-reach-estimate": "Facebook is currently unable to provide a reach estimate, please try in a bit",
			"request-change-of-target": "Request change of target",
			"target-change-modal-title": "Are you sure you want to change the target of this campaign?",
			"target-change-modal-description": "By clicking on \"Confirm\" an automatic request will be sent with the details of the new target selected.",
			"target-change-success": "The request of change of campaign target has been sent. The changes will be applied at the start of the next campaign month",
			"target-updated": "New target requested"
		},
		"checkout": {
			"save": "Save campaign",
			"appointedOnboarding-warning": "Saving disabled, Option \"Appointed Onboarding\" is not enabled on previous step",
			"remember": {
				"title": "Please remember",
				"description": "Once the campaign is saved, it cannot be modified."
			},
			"price": "{{ price, currency }} $t(pos.offer.context.{{ context }}.price)",
			"budget": "{{ price, currency }}"
		},
		"settings": {
			"has-facebook-page": "Customer has a Facebook page?",
			"facebook-email-same-as-customer": "Same as customer email",
			"create-landing-page": "Waiting for landing page",
			"landing-page-type": "$t(fn.complex.landing_page_type, { 'landing_page_type' : \"{{ type }}\" })",
			"confirm": "$t(terms.misc.confirm)",
			"move-to-checkout": "Move to Checkout",
			"facebook-page-mode": {
				"title": "Select Facebook Page creation mode:",
				"cancel": "$t(terms.misc.cancel)",
				"confirm": "$t(terms.misc.confirm)",
				"item": "$t(fn.complex.facebook_page_mode_description, { 'facebook_page_mode' : \"{{ value }}\", 'price': \"{{ price }}\" })"
			},
			"predicted-start-date": "$t(pos.settings.predicted-start-date-start) $t(fn.date, { 'timestamp': \"{{ date }}\" })",
			"predicted-start-date-start": "Predicted start",
			"facebook-page": {
				"connect": "Connect",
				"connected": "Connected",
				"accepted-toast": "Facebook page successfully connected",
				"should-accept-toast": "You need to accept our invitation to your page and reconnect after doing so.",
				"instruction": "Click here to accept your invitation. Reconnect page after doing so."
			},
			"notify-customer-also": "Also notify customer",
			"setup-offer": "Setup your offer",
			"appointed-onboarding": "Appointed Onboarding",
			"skip-onboarding": "Skip onboarding"
		},
		"offline": {
			"title": "Download offline files",
			"download-progress": "Downloaded {{ completed }} out of {{ total }} resources",
			"offline-mode-not-supported": "Offline mode not supported!",
			"check-internet-connection": "Please check your internet connection!",
			"update-files": "Please update your offline files!",
			"stay-connected-to-internet": "Please connect to WiFi and stay connected while this is in progress, because we will download lots of data",
			"enable-persistent-storage": "Please add site to home screen on your mobile device to use persistent storage",
			"offline-files-download-completed": "Offline files download completed",
			"error-while-downloading-files": "Error while download files, please try again!"
		},
		"not-found": {
			"title": "Not found",
			"create-new-campaign": "Click here to create a new campaign"
		},
		"postPreview": {
			"lead-form": {
				"thank_you_page": {
					"title": "Thanks, you're all set.",
					"message": "Your info has been successfully saved. Tap below to visit Us.",
					"button_text": "View Website"
				},
				"placeholder": {
					"email": "Lead email",
					"full_name": "Lead full name",
					"phone": "Lead phone",
					"post_code": "Post code",
					"enquiry": "Enter your answer"
				}
			}
		},
		"campaign-recommendation": {
			"category": "Category",
			"customer_id": "Sap ID",
			"marketing-goal-title": "Choose your customer's marketing goal",
			"other-goal-title": "Choose another available product",
			"proceed": "Proceed",
			"see-other-options": "See other options",
			"suggested-goal-title": "We think this product would be most suitable",
			"suggested-goal-ideal-for": "This is ideal for:",
			"title": "Goal Type recommendation"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.yml
// module id = 800
// module chunks = 1